import React from 'react';
import { Col, Row, Divider } from 'antd';
import UserDetailsCard from './components/UserDetailsCard';
import PasswordResetForm from './components/PasswordResetForm';
import AccountDeletions from './components/AccountDeletions';

const UserProfile = () => (
  <Row className="user-profile">
    <Col className="container">
      <Row>
        <Col className="header">
          <h1>Profile</h1>
          <h4>Manage your account settings</h4>
        </Col>
      </Row>

      <Row className="profile-con">
        <UserDetailsCard />
      </Row>
      <Row className="profile-con">
        <PasswordResetForm />
      </Row>

      <Divider style={{ borderColor: '#613937', margin: '2em 10%' }} />
      <Row className="profile-con">
        <AccountDeletions />
      </Row>
    </Col>
  </Row>
);

export default UserProfile;
